import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuardService} from '../../core/auth';
import {CustomerCreationPage, CustomerDetailsPage, CustomerListPage} from './pages/';


const routes: Routes = [
  {
    path: 'customer',
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    data: {roles: ['AC_MANAGE_CUSTOMER', 'AC_READ_CUSTOMER']},
    children: [
      {
        path: '',
        component: CustomerCreationPage,
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardService],
        data: {title: 'Customer Creation', roles: ['AC_MANAGE_CUSTOMER']}
      },
      {
        path: 'list',
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardService],
        component: CustomerListPage,
        data: {title: 'Customer Overview', roles: ['AC_MANAGE_CUSTOMER', 'AC_READ_CUSTOMER']}
      },
      {
        path: ':id',
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardService],
        component: CustomerDetailsPage,
        data: {title: 'Customer Details', roles: ['AC_MANAGE_CUSTOMER', 'AC_READ_CUSTOMER']}
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerRoutingModule {
}
